(function($) {
    var $nav = $("nav.mobile-nav");
    $(".nav-toggle").on('click', function () {
       $nav.addClass('show');
    });

    $(".nav-close").on("click", function () {
        $nav.removeClass('show');
    });

    $(window).on('resize', function(){
        if(window.innerWidth > 992){
            $nav.removeClass('show');
        }
    });

    $(window).on('load scroll', function(){
        var wScrollTop = $(window).scrollTop();
        if(wScrollTop > 50){
            $('nav.main-nav').addClass('sticky');
        } else {
            $('nav.main-nav').removeClass('sticky');
        }
    })


    function fixNav($parent){ 
        //Fix subnav positioning if off the screen
        $parent.find('.sub-menu').each(function(){
            $(this).removeClass('right');
            if( ($(this).offset().left + $(this).outerWidth()) > window.innerWidth  && window.innerWidth > 992){
                $(this).addClass('right');
            }
        });
    }
    $('.main-menu .menu-item').mousemove(function(){
        fixNav($(this));
    });

    fixNav( $('.main-menu') );

    //Only apply columns if there are more than a certain amount of children in sub menu, otherwise just show a single column
    $(document).ready(function(){
        console.log('Counting number of children each sub-menu has')
        $('nav.main-nav .bottom-nav ul.sub-menu').each(function(){
            if($(this).children('li').length < 7){
                $(this).addClass('single-column');
            }
        });

        //Add dropdown buttons on mobile
        $('nav.mobile-nav .main > ul > li.menu-item-has-children').each(function(){
            $(this).children('.sub-menu').before('<button class="mobile-nav-toggle"></button>');
        });

        var $navSliding = false;
        $(document).on('mousedown touchend', '.mobile-nav-toggle', function(e){
            e.preventDefault();

            if($navSliding == true)
                return;
            
            $(this).toggleClass('open');
            $navSliding = true;

            if($(this).hasClass('open')){
                $(this).next('.sub-menu').slideDown(function(){
                    $navSliding = false;
                });
            } else {
                $(this).next('.sub-menu').slideUp(function(){
                    $navSliding = false;
                });
            }

            return false;
        });
    });


})( jQuery );